


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { BDropdown, BDropdownItem, BDropdownDivider } from 'bootstrap-vue';
import { FormElementTag } from '@/models/FormElement';
import { mapGetters } from 'vuex';
import { Form } from '@/models/Form';
import ModalTagConfig from '@/components/modals/TagConfig.vue';

@Component({
    name: 'BaseFilter',
    components: {
        'modal-tag-config': ModalTagConfig,
        'b-dropdown': BDropdown,
        'b-dropdown-item': BDropdownItem,
        'b-dropdown-divider': BDropdownDivider,
    },
})
export default class BaseFilter extends Vue {
    @Prop() tag!: FormElementTag;
    @Prop() form!: Form;

    getFilter() {
        const filter = this.$route.query.filter;
        if (filter) {
            const f = JSON.parse(filter.toString());
            return !f.length ? [f] : f;
        } else {
            return [];
        }
    }

    mounted() {
        const id = this.tag.id;

        if (this.getFilter().indexOf(id) > -1) {
            this.$store.commit('formElementTags/activate', {
                form: this.form.uri,
                id,
            });
        }
    }

    toggle() {
        const filter = this.getFilter();
        const id = this.tag.id;

        if (this.tag.active) {
            const index = filter.indexOf(id);
            filter.splice(index, 1);
        } else {
            filter.push(id);
        }

        this.$store.commit(`formElementTags/${this.tag.active ? 'deactivate' : 'activate'}`, {
            form: this.form.uri,
            id,
        });

        this.$router.push({
            path: `/form/${this.form.id}`,
            query: filter.length ? { filter: JSON.stringify(filter) } : undefined,
        });
    }

    async remove() {
        try {
            if (this.tag.active) {
                this.toggle();
            }
            await this.$store.dispatch('formElementTags/delete', this.tag);
        } catch (e) {
            // TODO Catch 500 if tags are used in visibilty rules
        }
    }
}
